<template>
    <b-card border-variant="primary" header="Primary" header-bg-variant="primary" header-text-variant="white"
     :border-variant="border" @click="$emit('click')" 
     :no-body="!selected"
     body-class="p-1"
     >
      <template v-slot:header>
        <div v-if="edit && selected">
          <b-form>
            <b-form-group>
              <b-input-group size="sm">
                <b-form-input v-model="item.art_name" :id="'id_' + item?.art_id">
                  {{ item?.art_name }}
                </b-form-input>
                <b-input-group-append>
                  <b-button @click="setArtist()" variant="success">
                    <font-awesome-icon :icon="['fas', 'check']" />
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button variant="danger" @click="Cancel">
                    <font-awesome-icon :icon="['fas', 'times']" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-form>
        </div>
        <div v-else @dblclick="DblClicked()">
          {{ item?.art_name }}
          <b-button v-if="selected" pill variant="primary" @click="DblClicked()">
            <font-awesome-icon :icon="['fas', 'edit']" />
          </b-button>
        </div>
      </template>
      <template v-slot:default v-if="selected"  class="p-1">
        <img :src="imagePath" alt="Photo Artist" class="w-100 h-100"/>

      <div v-if="selected" class="text-left">
        <b-form-group cols="1" class=" p-0">
          <b-input-group size="sm">
            <b-form-file 
              v-if="editImage" 
              size="sm" 
              accept="image/*" 
              v-model="fileImage" 
              placeholder="Fichier"
              browse-text="..."
              @input="changeFile()"
              ></b-form-file>
            <b-input-group-append>
              <b-button  size="sm" class="noBorder" :pill="editImage ? false: true" 
                @click="toogleEditImage()"
                :variant="editImage ? 'success': 'outline-secondary'">
                <font-awesome-icon v-if="editImage" :icon="['fas', 'save']" />
                <font-awesome-icon v-if="!editImage" :icon="['fas', 'edit']" />
            </b-button>                  
            </b-input-group-append>
            <b-input-group-append>
              <b-button v-if="editImage" variant="danger" @click="CancelEditImage()">
                <font-awesome-icon :icon="['fas', 'times']" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>        
      </div>
      </template> 
      <template v-if="selected" v-slot:footer>
        <h6 class="mb-0">{{ item?.art_description }}</h6>
      </template>
    </b-card>
</template>

<script>
import { SaveArtist, SaveAsset } from '../services/music.js';
import defaultImage from '../services/data/iconArtist'
export default {

  props: {
    item: {
      type: Object,
      default: { art_id: null, art_name: "", art_description: "" },
    },
    // imagePath: {
    //   type: String,
    //   default: defaultImage
    // },
    selected: {
      type: Boolean,
      default: false
    }
  },
  name: 'ArtistCard',
  data() {
    return {
      edit: false,
      editImage: false,
      fileImage: null
    };
  },
  computed: {
    imagePath(){
      if (!this.item?.image) return defaultImage;
      return this.item.image;
    },
    border(){
      return (this.selected) ? 'primary' : 'secondary';
    },
    background(){
      return (this.selected) ? 'warning' : '';
    }
  },
  methods: {
    createBase64Image(FileObject) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.item.old.image = this.item.image;
        this.item.image = event.target.result;
      }
      reader.readAsDataURL(FileObject);
    },
    changeFile(){
      if (this.fileImage) {
        this.createBase64Image(this.fileImage)
      }
    },
    async setArtist() {
      if (this.item.modified()){
        const result = await SaveArtist(this.item);
      }
      this.edit = false;
    },
    Cancel() {
      this.edit = false;
    },
    DblClicked() {
      this.edit = true;
    },
    async toogleEditImage(){
      if (this.editImage){
        if (this.fileImage) {
          const result = await SaveAsset(this.item.art_id, 'ARTIST', this.fileImage, this.fileImage.name);
          if (result > 0) this.item.art_ass_id = result;
        }
      }
      this.editImage = !this.editImage;
    },
    CancelEditImage() {
      if (this.fileImage) {
        this.item.image = this.item.old.image;
        this.item.old.image = null;
        this.fileImage = null;
      }
      this.editImage = false;
    },

  },
}

</script>
<style>
.noBorder {
  border: 0px;
}
</style>